

import { sanitizeFilename } from "../sanitizeFilename";
import { resolveSlideDeckColorTheme } from "../../../data/slide-deck-generator/colorThemes";

export function slideDeckGeneratorToPptDocument(result) {
  const slides = result.slides.map((slide) => {
    const imageUrl = slide.imageDataUrl || slide.imageUrl || null;

    if (slide.layout === "title") {
      return {
        kind: "title",
        title: slide.title,
        subtitle: slide.bullets.join(" · ") || result.curriculumLabel,
        imageUrl,
      };
    }

    if (slide.layout === "section") {
      return {
        kind: "section",
        title: slide.title,
        body: slide.bullets.join("\n"),
        imageUrl,
      };
    }

    const bullets = [...slide.bullets];
    if (!imageUrl && slide.visualHint) {
      bullets.push(`Visual: ${slide.visualHint}`);
    }
    if (slide.speakerNotes) {
      bullets.push(`Notes: ${slide.speakerNotes}`);
    }

    return {
      kind: "bullets",
      title: slide.title,
      bullets,
      imageUrl,
    };
  });

  return {
    filename: sanitizeFilename(`${result.topicLabel} slide-deck`, "slide-deck"),
    title: result.pageTitle,
    subject: result.curriculumLabel,
    author: "Tema Slide Deck Generator",
    theme: resolveSlideDeckColorTheme(result.colorTheme).ppt,
    slides,
  };
}
